import { render, staticRenderFns } from "./ResumeCertificationItem.vue?vue&type=template&id=0ded54ab&"
import script from "./ResumeCertificationItem.vue?vue&type=script&lang=js&"
export * from "./ResumeCertificationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports